export const messageText = {
  CONFIRM_DELIVERY_QUESTION_TEXT: 'Confira com quem recebeu e avise a gente.'
};

export const messageTextsComplementaryInfoLayout = {
  CONFIRM_DELIVERY_QUESTION_TEXT: 'Você recebeu seu pacote?',
  CONFIRM_DELIVERY_QUESTION_TEXT_COMPLEMENT:
    'Confira com quem recebeu ou no local deixado: ',
  CONFIRM_DELIVERY_ID: 'confirm-delivery',
  LOCAL_TEXT: 'Onde foi deixado'
};

export const DENY_DELIVERY_BUTTON_TEXT = 'Não recebi';
export const CONFIRM_DELIVERY_BUTTON_TEXT = 'Sim, recebi';
export const CONFIRM_DELIVERY_ID = 'confirm-delivery';

export const DELIVERY_LOCATION_MAP = {
  INVALID: {
    option: 'INVALID',
    text: 'Quem recebeu'
  },
  RECIPIENT: {
    option: 'RECIPIENT',
    text: 'Quem recebeu'
  },
  OTHER_RECIPIENT: {
    option: 'OTHER_RECIPIENT',
    text: 'Relação com o destinatário'
  },
  CONCIERGE: {
    option: 'CONCIERGE',
    text: 'Na portaria'
  },
  MAILBOX: {
    option: 'MAILBOX',
    text: 'Na caixa de correspondência'
  },
  OTHER_OPTION: {
    option: 'OTHER_OPTION',
    text: 'Quem recebeu'
  }
};

export const DELIVERY_LOCATION = Object.values(DELIVERY_LOCATION_MAP);
